import styles from './style.module.css';
import React from 'react';
import {classes} from '@/util';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    className?: string;
    disabled?: boolean;
    variant?: 'primary' | 'secondary';
    children: React.ReactNode;
    icon?: React.ReactNode;
}

export function Button({
    className,
    children,
    variant = 'primary',
    disabled,
    icon,
    ...props
}: ButtonProps) {
    return (
        <button
            disabled={disabled}
            className={classes(className, styles.button, styles[variant], {
                [styles.disabled]: disabled,
            })}
            {...props}
        >
            {icon}
            {children}
        </button>
    );
}
